// utils/okxConstants.js
const BINANCE = 'binance'
const OKX = 'okx'

const CROSS = 'cross'
const ISOLATED = 'isolated'

const LONG = 'long'
const SHORT = 'short'

const BUY = 'buy'
const SELL = 'sell'

const CONDITIONAL = 'conditional'
const OCO = 'oco'
const CHASE = 'chase'
const TRIGGER = 'trigger'
const MOVEPRDERSTOP = 'move_order_stop'
const TWAP = 'twap'

const MARK = 'mark'
const LAST = 'last'
const INDEX = 'index'

module.exports = {
    BINANCE,
    OKX,
    CROSS,
    ISOLATED,
    LONG,
    SHORT,
    BUY,
    SELL,
    CONDITIONAL,
    OCO,
    CHASE,
    TRIGGER,
    MOVEPRDERSTOP,
    TWAP,
    MARK,
    LAST,
    INDEX,
}
